<template>
  <layout-default
    :floatingButton="!loading && isRoleAllowed"
    @floating-button-action="addNewBhUser"
  >
    <template v-slot:toolbar>
      <bh-users-filters
        :value="queryParams.fullName"
        @search-clear="searchClear"
        @search-on:input="searchInput"
        @search-on:run="searchRun"
      />
    </template>
    <div class="bh-users">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <main-user-table
        :headers="headers"
        :items="bhUsers"
        :items-per-page="queryParams.pageSize"
        :server-items-length="pagination.totalCount || -1"
        :page="queryParams.page"
        @to-user="toBhUser"
        @action:get-data="getDataAction"
      />
      <new-bh-user-dialog
        :show-dialog="showNewUserDialog"
        @close-dialog="closeNewUserDialog"
        @on-submit="onNewUserSubmit"
      />
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import BhUsersFilters from '@/components/bhUsers/BhUsersFilters.vue'
import NewBhUserDialog from '@/components/dialogs/NewBhUserDialog.vue'
import MainUserTable from '@/components/tables/MainUserTable'
import RouterMixin from '@/mixins/router'

export default {
  name: 'BhUsers',
  components: {
    LayoutDefault,
    BhUsersFilters,
    NewBhUserDialog,
    MainUserTable,
  },
  mixins: [RouterMixin],
  data() {
    return {
      defaultQueryParams: {
        sortBy: 'fullName',
        sortDirection: 'asc',
      },
      avatar: 'https://via.placeholder.com/54',
      headers: [
        { sortable: false },
        { text: 'Name', value: 'fullName' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Role', value: 'roleId' },
        { text: 'Date added', value: 'creationDate' },
      ],
      showNewUserDialog: false,
    }
  },
  computed: {
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('bhUsersStates', ['bhUsers', 'loading', 'pagination']),
    ...mapState('dictionariesStates', ['dictionaryBhUsersRoleIds']),
    isRoleAllowed() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ==
        this.dictionaryBhUsersRoleIds.Admin
      )
    },
  },
  methods: {
    ...mapActions('bhUsersStates', ['getBhUsers', 'addBhUser']),
    toBhUser(id) {
      this.$router.push({
        name: 'BH User',
        path: '/bhUsers/:id',
        params: { id: id },
      })
    },
    searchClear() {
      this.getDataAction({ ...this.defaultQueryParams })
    },
    searchInput({ key, value }) {
      this.getDataAction({ ...this.defaultQueryParams, [key]: value })
    },
    searchRun(search) {
      this.getDataAction({ ...this.defaultQueryParams, firstName: search })
    },
    addNewBhUser() {
      this.showNewUserDialog = true
    },
    closeNewUserDialog() {
      this.showNewUserDialog = false
    },
    onNewUserSubmit(userData) {
      this.addBhUser(userData)
    },
    getData(data) {
      this.getBhUsers(data)
    },
  },
}
</script>

<style lang="scss">
// scoped is not working as styles are used from different place
@import '@/styles/variables.scss';

.bh-users {
  padding: 2 * $gutter;
}
</style>
